<div class="dropdown">
  <button
    class="btn btn-outline-success btn-round"
    type="button"
    (click)="onToggle()"
    >
    Initialize Transfer Commission
  </button>
  @if (form) {
    <form #filterForm="ngForm" (ngSubmit)="onSubmit()">
      <ul
        style="margin-top: 10px"
        class="filterBox filter"
        [class.show]="display"
        [appDraggable]="true"
        >
        <h3
          class="dropdown-header m-0 filter-header show"
          style="margin: 25px 20px"
          >
          <span class="grey darken-2">Initialize Transfer Commission</span>
          <button
            data-dismiss="filter"
            aria-label="Close"
            (click)="onToggle()"
            class="notification-tag float-right m-0 close"
            >
            ×
          </button>
        </h3>
        @if (errorMessage) {
          <div class="alert alert-danger">
            {{ errorMessage }}
          </div>
        }
        <li class="dropdown-header m-0">
          <div class="form-group row">
            <label for="bank_name" class="col-sm-4 col-form-label"
              >Bank Name</label
              >
              <div class="col-sm-8">
                <select
                  class="form-control round"
                  name="account_bank"
                  id="bank_name"
                  [(ngModel)]="model.account_bank"
                  >
                  @for (bank of banks; track bank) {
                    <option [value]="bank.code">
                      {{ bank.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </li>
          <li class="dropdown-header m-0">
            <div class="form-group row">
              <label for="account_number" class="col-sm-4 col-form-label"
                >Account Number</label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control round"
                    name="account_number"
                    id="account_number"
                    (input)="onAccountNumberChange()"
                    [(ngModel)]="model.account_number"
                    />
                </div>
              </div>
            </li>
            <li class="dropdown-header m-0">
              <div class="form-group row">
                <label for="beneficiary_name" class="col-sm-4 col-form-label"
                  >Beneficiary Name</label
                  >
                  <div class="col-sm-8 d-flex align-self-center">
                    {{ bank_account_name }}
                  </div>
                </div>
              </li>
              <li class="dropdown-header m-0">
                <div class="form-group row">
                  <label for="amount" class="col-sm-4 col-form-label">Amount</label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      class="form-control round"
                      name="amount"
                      id="amount"
                      [(ngModel)]="model.amount"
                      />
                  </div>
                </div>
              </li>
              <li class="dropdown-header m-0">
                <div class="form-group row">
                  <label for="narration" class="col-sm-4 col-form-label"
                    >Narration</label
                    >
                    <div class="col-sm-8">
                      <textarea
                        class="form-control round"
                        name="narration"
                        id="narration"
                        rows="3"
                        [(ngModel)]="model.narration"
                      ></textarea>
                    </div>
                  </div>
                </li>
                <li class="dropdown-header m-0">
                  <div class="form-group row">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-12 pull-right">
                      <button
                        type="submit"
                        class="btn btn-success btn-round pl-30 pr-30 pull-right"
                        [disabled]="isLoading === true"
                        >
                        Submit
                        @if (isLoading === true) {
                          <i class="icons icon-loading"></i>
                        }
                      </button>
                      <button
                        type="button"
                        (click)="onToggle()"
                        class="btn reset pl-30 pr-30 pull-right"
                        >
                        Cancel
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </form>
          }
        </div>
